import { BaseModel } from "@/models/base.model"
import { type ITenant } from "@/interfaces/api/tenant.interface"
import { TenantSettings } from "@/models/tenant_settings/tenant-settings.model"
import { ModelFactory } from "@/factories/model-factory"

export class Tenant extends BaseModel implements ITenant {
  public static className = "Tenant" // Used for socket communication.

  public static verboseName = "tenant"

  name: string

  tenantSettings: TenantSettings | null

  constructor(tenant: ITenant, managed = false) {
    super(tenant)

    this.name = tenant.name

    this.tenantSettings = tenant.tenantSettings
      ? ModelFactory.childModel(TenantSettings, tenant.tenantSettings, managed)
      : null
  }
}
